import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import { Person, Email } from '@mui/icons-material';
import AgentAvatar from '../pages/AgentAvatar';

const ChipContainer = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: '6px',
  padding: '4px 10px 4px 4px',
  margin: '0 8px 8px 0',
  backgroundColor: '#f8f8f8',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
  transition: 'all 0.2s ease',
  minWidth: '100px',
  maxWidth: '220px',
  '&:hover': {
    backgroundColor: '#f0f0f0',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
    transform: 'translateY(-1px)',
  },
}));

const NameText = styled('span')({
  marginLeft: '10px',
  fontSize: '0.875rem',
  fontWeight: 500,
  color: 'rgba(0, 0, 0, 0.8)',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexGrow: 1,
  maxWidth: '160px',
});

const IconContainer = styled(Box)({
  display: 'flex',
  marginLeft: '8px',
  opacity: 0.6,
  '& .MuiSvgIcon-root': {
    fontSize: '14px',
  },
});

const assigneeAvatarSx = {
  border: '1.5px solid white',
  mr: '2px',
};

/**
 * TaskAssigneeChip - Modern chip component combining avatar and user display name
 *
 * @param {Object} props
 * @param {string|Object} props.user - User data (string or object)
 * @param {string} props.userType - Type of user ("USER" or "EMAIL")
 * @param {boolean} props.isExternal - Whether the task is external
 */
const TaskAssigneeChip = ({ user, userType = 'USER', isExternal = false }) => {
  const displayName =
    typeof user === 'object' ? user.displayName || user.email || user.id || user.userId : user;

  const userIcon = userType === 'EMAIL' ? <Email /> : <Person />;

  return (
    <Tooltip title={displayName}>
      <ChipContainer>
        <AgentAvatar name={displayName} size={26} borderRadius="6px" fontSize="0.75rem" sx={assigneeAvatarSx} />
        <NameText>{displayName}</NameText>
        <IconContainer>{userIcon}</IconContainer>
      </ChipContainer>
    </Tooltip>
  );
};

export default TaskAssigneeChip;
